import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import useTranslation from '@hooks/useTranslation';

import type { ITimezone } from '@model/timezone';

import { apiClient } from '@services/apiClient';

export const timezoneKey = () => ['timezone'];
export const timezoneFn = () => apiClient.get(`${APP_SSO_URL}api/timezone`);

const timezoneSelect = (data: Array<ITimezone>, t: (text: string) => string) => {
  const timezoneList = data?.map((timezone) => {
    return { ...timezone, title: t(timezone.title) };
  });

  return timezoneList;
};

export const useTimezoneQuery = () => {
  const { t } = useTranslation();

  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: timezoneKey(),
    queryFn: timezoneFn,
    select: ({ data }: AxiosResponse<Array<ITimezone>>) => timezoneSelect(data, t),
  });
};
